var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"id":"page-top"}},[_c('app-toolbar'),_c('div',{class:{ 'new-theme': _vm.newTheme }},[_c('app-view')],1),_c('app-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }